export const PUBLISH_STATUS_DRAFT = 'draft';
export const PUBLISH_STATUS_SCHEDULED = 'scheduled';
export const PUBLISH_STATUS_PUBLISHED = 'published';
export const PUBLISH_STATUS_DISABLED = 'disabled';

export const TICKET_SALE_DURATION_TYPE_DURATION = 'duration';
export const TICKET_SALE_DURATION_TYPE_BEFORE_SLOT_START = 'days_before_slot_starts';

export const TAB_WEBINAR_INTRODUCTION = 'webinar_introduction';
export const TAB_WEBINAR_INFORMATION = 'webinar_information';
export const TAB_WEBINAR_CONSIDERATIONS = 'webinar_considerations';

/**
 * 直播分頁 → i18n key 的明確 mapping。
 *
 * 不寫成 t(`training:course:webinar:${tab}`)：那等於宣告 webinar 底下 26 個 key
 * 都可能被動態取用，之後沒有人能安全刪改。（同 src/const/event.ts 的做法。）
 */
export const WEBINAR_TAB_I18N_KEYS = {
	[TAB_WEBINAR_INTRODUCTION]: 'training:course:webinar:webinar_introduction',
	[TAB_WEBINAR_INFORMATION]: 'training:course:webinar:webinar_information',
	[TAB_WEBINAR_CONSIDERATIONS]: 'training:course:webinar:webinar_considerations',
} as const;

/**
 * 後端 link_type enum → i18n key。
 *
 * 這組值只存在於後端與 locale，程式裡沒有常數，所以未知值一定要有 fallback。
 */
export const WEBINAR_LINK_TYPE_I18N_KEYS = {
	youtube: 'training:course:webinar:link_type:youtube',
	zoom: 'training:course:webinar:link_type:zoom',
	google_meet: 'training:course:webinar:link_type:google_meet',
	microsoft_teams: 'training:course:webinar:link_type:microsoft_teams',
} as const;

/** 翻譯直播平台；未知值退回後端原字串，不讓畫面露出 raw key。 */
export const translateWebinarLinkType = (
	t: (key: string) => string,
	value?: string | null,
): string => {
	const key = WEBINAR_LINK_TYPE_I18N_KEYS[value as keyof typeof WEBINAR_LINK_TYPE_I18N_KEYS];
	return key ? t(key) : (value || '');
};

export const WEBINAR_DROPDOWN_ANCHOR = 'WEBINAR_DROPDOWN_ANCHOR';

export const DEFAULT_SLOT_TYPE = '';
export const DEFAULT_TICKET_TYPE = '';
